import { MonitorInstallTypesV1, VesselTypes } from '@geckoal/gecko-api-client'

export type MonitorInstallTypesItem = {
    value: MonitorInstallTypesV1
    shortTitle: string
    longTitle: string
}

export const ALL_MONITOR_INSTALL_TYPES: MonitorInstallTypesItem[] = [
    {
        value: MonitorInstallTypesV1.Poolside,
        shortTitle: titleForMonitorInstallType(MonitorInstallTypesV1.Poolside),
        longTitle: `${titleForMonitorInstallType(MonitorInstallTypesV1.Poolside)} - Sensor submerged`
    },
    {
        value: MonitorInstallTypesV1.Inline,
        shortTitle: titleForMonitorInstallType(MonitorInstallTypesV1.Inline),
        longTitle: `${titleForMonitorInstallType(MonitorInstallTypesV1.Inline)} - Sensor installed in plumbing`
    }
]

export function titleForMonitorInstallType(installType: MonitorInstallTypesV1 | string, vesselType?: VesselTypes): string {
    if (installType === MonitorInstallTypesV1.Poolside) {
        if (vesselType === undefined) return 'Poolside/Spaside'
        if (vesselType === VesselTypes.Hottub || vesselType === VesselTypes.Swimspa) return 'Spaside'
        return 'Poolside'
    }
    if (installType === MonitorInstallTypesV1.Inline) return 'Inline'
    return installType
}
